import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "card shadow-sm p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 text-center" }, " Conectar WhatsApp ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-center" }, " Para conectar seu WhatsApp, siga as instruções abaixo: ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ol", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Abra o aplicativo do WhatsApp no seu celular."),
  /*#__PURE__*/_createElementVNode("li", null, "Acesse \"Aparelhos conectados\"."),
  /*#__PURE__*/_createElementVNode("li", null, "Escaneie o QR Code exibido abaixo.")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "qr-container mb-4"
}
const _hoisted_7 = {
  key: 0,
  src: "/public/images/qrCode.png",
  class: "qr-fake"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "qr-loading"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "Loading" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "card bg-light p-3 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 mb-2" }, " Status ", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-success fw-bold"
}
const _hoisted_15 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_16 = {
  key: 0,
  class: "modal-backdrop-custom"
}
const _hoisted_17 = { class: "modal-custom" }
const _hoisted_18 = { class: "modal-header" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, " Configurações WhatsApp ", -1)
const _hoisted_20 = { class: "modal-body" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Número ", -1)
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Token ", -1)
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " URL ", -1)
const _hoisted_27 = { class: "modal-footer" }

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import axios from 'axios'
import useAlert from '@/composables/Alert'
import useWhatsapp from '@/composables/useWhatsapp'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConectWhatsApp',
  setup(__props) {

const { status, isConnected, getStatus, startPolling, stopPolling } = useWhatsapp()
const qrCode = ref<string | null>(null)
const loadingQrCode = ref(false)
const { showTimeAlert } = useAlert()
const openSettings = ref(false)
const form = ref({
    phone: '',
    token: '',
    url: '',
    active: true
})

function openSettingsModal() {
    openSettings.value = true

    nextTick(() => {
        const el = document.querySelector<HTMLElement>('.modal-custom')
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    })
}

async function getQRCode() {
    try {
        loadingQrCode.value = true

        await getStatus()

        if (status.value !== 'disconnected') {
            qrCode.value = null
            return
        }

        const response = await axios.get('/api/whatsapp/qrCode', {
            responseType: 'blob'
        })

        if (qrCode.value) {
            URL.revokeObjectURL(qrCode.value)
        }

        qrCode.value = URL.createObjectURL(response.data)

    } catch (error) {
        const msg = (error as any)?.response?.data?.message || 'Erro ao obter QR Code'
        showTimeAlert(msg, 'error')
        qrCode.value = null
    } finally {
        loadingQrCode.value = false
    }
}

async function getSettings() {
    try {
        const response = await axios.get('/api/whatsapp/config')

        const cfg = response.data && response.data.data ? response.data.data : response.data

        form.value = {
            phone: cfg?.phone ?? cfg?.telefone ?? '',
            token: cfg?.token ?? cfg?.access_token ?? '',
            url: cfg?.url ?? cfg?.endpoint ?? '',
            active: cfg?.active === 1 || cfg?.active === '1' || cfg?.active === true
        }
    } catch (error) {
        const msg = (error as any)?.response?.data?.message || 'Erro ao obter configurações'
        showTimeAlert(msg, 'error')
    }
}

async function saveSettings() {
    try {
        const payload = {
            ...form.value,
            active: form.value.active ? 1 : 0
        }

        await axios.put('/api/whatsapp/putConfig', payload)

        showTimeAlert('Configurações salvas com sucesso!', 'success')

        openSettings.value = false
    } catch (error) {
        const msg = (error as any)?.response?.data?.message || 'Erro ao salvar configurações'
        showTimeAlert(msg, 'error')
    }
}

onMounted(async () => {
    await getSettings()

    await startPolling()

    if (status.value === 'disconnected') {
        await getQRCode()
    }

})

onBeforeUnmount(() => {

    if (qrCode.value) {
        URL.revokeObjectURL(qrCode.value)
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        (!_unref(isConnected))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_unref(isConnected))
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (qrCode.value && !loadingQrCode.value && !_unref(isConnected))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: qrCode.value,
                    class: "qr-real"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (loadingQrCode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
              (!_unref(isConnected) && !loadingQrCode.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: getQRCode,
                    class: "qr-refresh"
                  }, " ⟳ "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_unref(isConnected))
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Número conectado com sucesso ✅ "))
            : (_openBlock(), _createElementBlock("p", _hoisted_15, " WhatsApp não conectado. Escaneie o QR Code. "))
        ]),
        _createElementVNode("div", { class: "text-center mt-4" }, [
          _createElementVNode("button", {
            class: "btn-config",
            onClick: openSettingsModal
          }, " Configurações ")
        ])
      ])
    ]),
    (openSettings.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openSettings.value = false))
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.phone) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "5531999999999"
                }, null, 512), [
                  [_vModelText, form.value.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.token) = $event)),
                  type: "text",
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, form.value.token]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.url) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "https://api.whatsapp.com/"
                }, null, 512), [
                  [_vModelText, form.value.url]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (openSettings.value = false))
              }, " Cancelar "),
              _createElementVNode("button", {
                class: "btn btn-success",
                onClick: saveSettings
              }, " Salvar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})